import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/auth'
import './auth.scss'

function Login() {
	const { login, resendVerification } = useAuth()
	const navigate = useNavigate()

	const [email, setEmail]       = useState('')
	const [password, setPassword] = useState('')
	const [error, setError]       = useState('')
	const [unverified, setUnverified] = useState(false)
	const [resent, setResent]     = useState(false)
	const [loading, setLoading]   = useState(false)

	async function handleSubmit(e) {
		e.preventDefault()
		setError('')
		setUnverified(false)
		setLoading(true)
		try {
			await login(email, password)
			navigate('/')
		} catch (err) {
			if (err.code === 'EMAIL_NOT_VERIFIED') setUnverified(true)
			else setError(err.message)
		} finally {
			setLoading(false)
		}
	}

	async function handleResend() {
		await resendVerification(email)
		setResent(true)
	}

	return (
		<div className='authPage'>
			<div className='authCard'>
				<h2>Log in</h2>

				{error && <div className='authError'>{error}</div>}

				{unverified && (
					<div className='authError'>
						Your email is not verified.{' '}
						{resent
							? 'A new link has been sent.'
							: <button className='authLinkBtn' onClick={handleResend}>Resend verification email</button>}
					</div>
				)}

				<form onSubmit={handleSubmit}>
					<div className='authField'>
						<label>Email</label>
						<input
							type='email'
							value={email}
							onChange={e => setEmail(e.target.value)}
							required
							autoFocus
						/>
					</div>
					<div className='authField'>
						<label>Password</label>
						<input
							type='password'
							value={password}
							onChange={e => setPassword(e.target.value)}
							required
						/>
					</div>
					<button className='authBtn' disabled={loading}>
						{loading ? 'Logging in…' : 'Log in'}
					</button>
				</form>

				<div className='authLinks'>
					<Link to='/forgot-password'>Forgot your password?</Link>
					<Link to='/register'>No account yet? Register</Link>
				</div>
			</div>
		</div>
	)
}

export default Login
